import React from 'react';
import { Row, Col } from 'antd';
import { formatPerm, isMultiCheckboxDisabled, writeControlledPermissions } from './permissionConstants';
import OnTraccrSwitch from '../common/inputs/OnTraccrSwitch';

const isChecked = (key, role, position = []) => (
  position.some((perm) => perm === formatPerm(key, role))
);

export default function RoleCheckboxes({
  myRole,
  positions = {},
  callback,
  key,
  reports,
  disabled = false,
  t,
}) {
  const isReports = key === 'reports_view';
  const splitRows = !isReports ? [['Self']] : [[]];
  const roles = isReports ? reports : Object.keys(positions);

  roles.forEach((row) => {
    let last = splitRows.length - 1;
    if (splitRows[last].length === 5) {
      splitRows.push([]);
      last += 1;
    }
    splitRows[last].push(row);
  });
  return splitRows.map((row, index) => (
    <Row key={index}>
      {row.map((role) => (
        <Col key={role} span={8}>
          <OnTraccrSwitch
            value={isChecked(key, role, positions[myRole])}
            key={role}
            onChange={() => {
              callback(formatPerm(key, role));
              const perms = positions[myRole];
              if (writeControlledPermissions.has(key)) {
                let writePerm;
                let certAddPerm;
                let certManagePerm;

                const readPerm = formatPerm(key, role);

                if (key === 'users_view') {
                  writePerm = formatPerm('users', role);
                  certAddPerm = formatPerm('ADD_CERTIFICATIONS_USER', role);
                  certManagePerm = formatPerm('manage_user_certifications', role);
                } else {
                  writePerm = readPerm.replace('VIEW', 'EDIT');
                }

                let hasRead;
                let hasWrite;
                let hasCertAdd;
                let hasCertManage;

                perms.forEach((perm) => {
                  if (perm === readPerm) {
                    hasRead = true;
                  } else if (perm === writePerm) {
                    hasWrite = true;
                  } else if (perm === certAddPerm) {
                    hasCertAdd = true;
                  } else if (perm === certManagePerm) {
                    hasCertManage = true;
                  }
                });

                if (hasRead && hasWrite) callback(writePerm);
                if (hasRead && hasCertAdd) callback(certAddPerm);
                if (hasRead && hasCertManage) callback(certManagePerm);
              }
            }}
            style={{ marginTop: 10 }}
            disabled={disabled || isMultiCheckboxDisabled(key, role, positions[myRole])}
            title={(
              <span
                style={{
                  display: 'inline-block',
                  maxWidth: '120px',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                }}
              >
                {t(role, { project: t('Project') })}
              </span>
            )}
            useRightView
          />
        </Col>
      ))}
    </Row>
  ));
}
